import React from 'react'
import PropTypes from 'prop-types'

/**
 * Table cell component
 *
 * @param {Object} props - Component props
 * @param {string} props.className - Additional CSS classes
 * @param {Object} props.style - Inline styles
 */
const TableCell = ({ className = '', style = null, children = null, ...props }) => (
  <td className={className} style={style} {...props}>
    {children}
  </td>
)

TableCell.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.shape({})
}

TableCell.defaultProps = {
  children: null,
  className: '',
  style: null
}

export default TableCell
